import { z } from '@harvestiq/zod';
import { policyProducerEventMsgSchema } from '../policy-producer/policy-producer-event-msg';
import { lrpPremiumEventMsgSchema } from '../lrp-premium/lrp-premium-event-msg';
import { lgmPremiumEventMsgSchema } from '../lgm-premium/lgm-premium-event-msg';
import { syncAipMsgSchema } from '../sync/sync-aip-msg';

export const aipEventMessageSchema = z.discriminatedUnion('eventType', [
  policyProducerEventMsgSchema,
  lrpPremiumEventMsgSchema,
  lgmPremiumEventMsgSchema,
  syncAipMsgSchema,
]);
export type AipEventMessage = z.infer<typeof aipEventMessageSchema>;
